
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class ErrorPage extends Vue {
  @Prop() error!: any
}
